import { faHeadset, faRobot } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

import { withIcon } from '../../../core/components/Icon.tsx';
import classnames from '../../../core/utils/classnames.tsx';
import { AssistantKind } from '../utils/adaptAssistant.ts';

const TYPE_ICONS: Record<AssistantKind, ReturnType<typeof withIcon>> = {
    inboxAgent: withIcon(faRobot),
    voiceAgent: withIcon(faHeadset),
};

const AssistantTypeStep = ({
    types,
    value,
    onChange,
}: {
    types: AssistantKind[];
    value: AssistantKind;
    onChange: (kind: AssistantKind) => void;
}) => {
    const { t } = useTranslation('assistants');

    return (
        <div role="radiogroup" aria-label={t('wizard.type.title')} className="flex flex-col gap-3">
            {types.map((kind) => {
                const Icon = TYPE_ICONS[kind];
                const selected = kind === value;
                return (
                    <button
                        key={kind}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        onClick={() => onChange(kind)}
                        className={classnames(
                            'flex cursor-pointer flex-col gap-1 rounded-lg border border-solid p-4 text-left transition-colors focus-visible:ring-2 focus-visible:ring-line-brand-strong',
                            selected
                                ? 'border-line-brand-default bg-surface-brand-weak'
                                : 'border-line-weak bg-surface-weak hover:bg-surface-medium active:bg-surface-strong'
                        )}
                    >
                        <span className="flex items-center gap-2 text-sm font-medium text-content-strong">
                            <Icon className="text-content-agent-default" />
                            {t(`wizard.type.${kind}.title`)}
                        </span>
                        <span className="text-sm text-content-medium">{t(`wizard.type.${kind}.description`)}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default AssistantTypeStep;
